/**
 * Safe localStorage wrappers.
 *
 * Some browsers throw on `localStorage` access — iOS private browsing,
 * restrictive in-app webviews (e.g. some banking app browsers), third-party
 * cookie blocking with site data also blocked, and tightened-down corporate
 * profiles. An *unguarded* `localStorage.getItem(...)` inside a React render
 * throws synchronously, which crashes the component tree above any error
 * boundary that doesn't catch it → users see a black screen.
 *
 * Always use these helpers in render paths.
 */

let memoryFallback = {};

export function lsGet(key) {
  try {
    const v = window.localStorage.getItem(key);
    return v;
  } catch {
    return memoryFallback[key] ?? null;
  }
}

export function lsSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    memoryFallback[key] = value;
  }
}

export function lsRemove(key) {
  try {
    window.localStorage.removeItem(key);
  } catch {
    delete memoryFallback[key];
  }
}
